import React from 'react';

export const AmrBasicDataPackageListComponent = () => {
    return (
        <ul>
            <li>Surveillance Data</li>
        </ul>
    );
};
